import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__shape-1 float-bob-y">
        <img src="assets/images/shapes/site-footer-shape-1.png" alt="" />
      </div>
      <div className="site-footer__top">
        <div className="container">
          <div className="site-footer__top-inner">
            <div className="site-footer__top-left"></div>
            <div className="site-footer__top-right">
              <div className="site-footer__social-shape-1 float-bob-y">
                <img src="assets/images/shapes/site-footer-social-shape.png" alt="" className="zoom-fade" />
              </div>
              <div className="site-footer__social-title">
                <p>Follow on:</p>
              </div>
              <div className="site-footer__social">
                <a href="https://twitter.com" title="Twitter"><i className="fab fa-twitter"></i></a>
                <a href="https://facebook.com" title="Facebook"><i className="fab fa-facebook"></i></a>
                <a href="https://pinterest.com" title="Pinterest"><i className="fab fa-pinterest-p"></i></a>
                <a href="https://instagram.com" title="Instagram"><i className="fab fa-instagram"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="site-footer__middle">
          <div className="row">
            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
              <div className="footer-widget__column footer-widget__about">
                <div className="footer-widget__logo">
                  <Link to="/"><img src="assets/images/PsychMitra.png" alt="Logo" style={{ maxHeight: '120px', width: 'auto' }} /></Link>
                </div>
                <p className="footer-widget__about-text">One stop destination for all your mental health needs.</p>
              </div>
            </div>
            <div className="col-xl-2 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
              <div className="footer-widget__column footer-widget__link">
                <div className="footer-widget__title-box">
                  <h3 className="footer-widget__title">Explore</h3>
                </div>
                <ul className="footer-widget__link-list list-unstyled">
                  <li><Link to="/about">About</Link></li>
                  <li><Link to="/register/client">Book Appointment</Link></li>
                  <li><Link to="/blog">Latest News</Link></li>
                  <li><Link to="/therapists">Our Practitioners</Link></li>
                  <li><Link to="/faq">FAQs</Link></li>
                  <li><Link to="/contact">Contact</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
              <div className="footer-widget__column footer-widget__Contact">
                <div className="footer-widget__title-box">
                  <h3 className="footer-widget__title">Contact</h3>
                </div>
                <ul className="footer-widget__Contact-list list-unstyled">
                  <li>
                    <div className="icon">
                      <span className="fas fa-map-marker"></span>
                    </div>
                    <div className="text">
                      <span>Visit Office</span>
                      <p>66 Broklyn Gold Street. USA</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="fas fa-envelope"></span>
                    </div>
                    <div className="text">
                      <span>Send Email</span>
                      <p><a href="mailto:needhelp@company.com">needhelp@company.com</a></p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="fas fa-phone-square"></span>
                    </div>
                    <div className="text">
                      <span>Call Anytime</span>
                      <p><a href="tel:+926668880000">+92 (666) 888 0000</a></p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
              <div className="footer-widget__column footer-widget__newsletter">
                <div className="footer-widget__title-box">
                  <h3 className="footer-widget__title">Newsletter</h3>
                </div>
                <p className="footer-widget__newsletter-text">Subscribe our newsletter to get latest updates</p>
                <form className="footer-widget__email-box">
                  <div className="footer-widget__email-input-box">
                    <input type="email" placeholder="Email address" name="email" />
                  </div>
                  <button type="submit" className="footer-widget__subscribe-btn thm-btn">Register Yourself</button>
                </form>
                <div className="mc-form__response"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="site-footer__bottom">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="site-footer__bottom-inner">
                <p className="site-footer__bottom-text">© Copyright 2026 by <a href="https://globalwebpackage.com/">Global Web Package Pvt. Ltd.</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
